import { createAllActions } from '@api/createRequestStore';
import addScrollingWindow from '@utils/addScrollingWindow';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const updateDashboard = (payload, id, createThenMakeDefault, makeDefaultFn) => ({
  type: types.UPDATE_DASHBOARD,
  payload: addScrollingWindow(payload),
  id,
  createThenMakeDefault,
  makeDefaultFn,
});

export const updateDashboardById = (id, dashboardName, dashboard, showNotification = true) => ({
  type: types.UPDATE_DASHBOARD_BY_ID,
  id,
  dashboardName,
  dashboard: addScrollingWindow(dashboard),
  showNotification,
});

const { init: initRequest, fetching } = createAllActions(types.SCOPE);

export { initRequest, fetching };
